// deno-fmt-ignore-file
import { Memory } from '../../../system/memory/index.mjs';
export function TemplateLiteralCreate(pattern) {
    return Memory.Create({ ['~kind']: 'TemplateLiteral' }, { type: 'string', pattern }, {});
}
